require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-favorite-student-resources-for-staying-up-to-date-stack-specific.json") })
        }
      }, "path---blog-favorite-student-resources-for-staying-up-to-date-stack-specific");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-favorite-student-resources-for-staying-up-to-date-stack-specific!./.cache/json/blog-favorite-student-resources-for-staying-up-to-date-stack-specific.json
// module id = 798
// module chunks = 231608221292675